import { jsx as o } from "react/jsx-runtime";
function e(t) {
  return /* @__PURE__ */ o(
    "svg",
    {
      width: "11",
      height: "14",
      viewBox: "0 0 11 14",
      fill: "none",
      stroke: "rgb(var(--text-secondary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      children: /* @__PURE__ */ o(
        "path",
        {
          d: "M1 7H6.33333C7.80609 7 9 5.80609 9 4.33333C9 2.86057 7.80609 1.66666 6.33333 1.66666H1V7ZM1 7H7C8.47276 7 9.66667 8.1939 9.66667 9.66666C9.66667 11.1394 8.47276 12.3333 7 12.3333H1V7Z",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    }
  );
}
export {
  e as default
};
